import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import { CurrentPlanTag } from '../current-plan-tag';
import { NextChargeTag } from '../next-charge-tag';
import { ScaleOnDemandTag } from '../scale-on-demand-tag';
import * as Styled from './styles';
import * as SX from './sx';
import type { PlanTagsProps as Props } from './types';

export const PlanTags = memo(({ className }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('PlanTags', className)}
      sx={SX.root}
      direction="row"
    >
      <ScaleOnDemandTag />
      <CurrentPlanTag />
      <NextChargeTag />
    </Styled.Wrapper>
  );
});

PlanTags.displayName = 'PlanTags';
